import React from "react";
// export const apiurl = "http://localhost:5050";
// export const apiurl = "https://suwasthi-workspace-engine.onrender.com";
export const apiurl = "https://api.suwasthi.in";
